/*
 * Symbolset
 * www.symbolset.com
 * Copyright © 2013 Oak Studios LLC
 *
 * Upload this file to your web server
 * and place this before the closing </body> tag.
 * <script src="webfonts/ss-pika.js"></script>
 */

if (
  /(MSIE [7-9]\.|Opera.*Version\/(10\.[5-9]|(11|12)\.)|Chrome\/([1-9]|10)\.|Version\/[2-4][\.0-9]+ Safari\/|Version\/(4\.0\.[4-9]|4\.[1-9]|5\.0)[\.0-9]+? Mobile\/.*Safari\/|Android ([1-2]|4\.[2-9].*Version\/4)\.|BlackBerry.*WebKit)/.test(
    navigator.userAgent
  ) &&
  !/(IEMobile)/.test(navigator.userAgent)
) {
  if (/Android 4\.[2-9].*Version\/4/.test(navigator.userAgent)) {
    const ss_android = document.createElement('style');
    ss_android.innerHTML =
      '.ss-icon,[class^="ss-"],[class*=" ss-"],[class^="ss-"]:before,[class*=" ss-"]:before,[class^="ss-"].right:after[class*=" ss-"].right:after{text-rendering:auto!important}';
    document.body.appendChild(ss_android);
  }

  const ss_set = {
    'notifications disabled': '\uD83D\uDD15',
    'wheelchair accessible': '\u267F',
    notificationsdisabled: '\uD83D\uDD15',
    'notification disabled': '\uD83D\uDD15',
    'waxing crescent moon': '\uD83C\uDF12',
    'waning crescent moon': '\uD83C\uDF18',
    wheelchairaccessible: '\u267F',
    notificationdisabled: '\uD83D\uDD15',
    'waxing gibbous moon': '\uD83C\uDF14',
    'waning gibbous moon': '\uD83C\uDF16',
    'telephone disabled': '\uE300',
    'print registration': '\uED44',
    waningcrescentmoon: '\uD83C\uDF18',
    'first quarter moon': '\uD83C\uDF13',
    'wine glass sparkle': '\uD83C\uDF77',
    waxingcrescentmoon: '\uD83C\uDF12',
    waxinggibbousmoon: '\uD83C\uDF14',
    'last quarter moon': '\uD83C\uDF17',
    printregistration: '\uED44',
    'capsule recycling': '\uEFFA',
    telephonedisabled: '\uE300',
    waninggibbousmoon: '\uD83C\uDF16',
    'thermometer down': '\uF204',
    'charging battery': '\uEA14',
    firstquartermoon: '\uD83C\uDF13',
    'writing disabled': '\uE071',
    wineglasssparkle: '\uD83C\uDF77',
    capsulerecycling: '\uEFFA',
    'point down right': '\uF511',
    'cooking utensils': '\uF151',
    'download folder': '\uEC76',
    cookingutensils: '\uF151',
    lastquartermoon: '\uD83C\uDF17',
    'electric kettle': '\uF195',
    writingdisabled: '\uE071',
    'pencil disabled': '\uE071',
    thermometerdown: '\uF204',
    'point down left': '\uF512',
    chargingbattery: '\uEA14',
    'touchtone phone': '\u260F',
    'rainbow clouds': '\uF214',
    'thermometer up': '\uF203',
    pencildisabled: '\uE071',
    touchtonephone: '\u260F',
    'point up right': '\uF510',
    'medium battery': '\uEA11',
    pointdownright: '\uF511',
    electrickettle: '\uF195',
    'phone disabled': '\uE300',
    'insert capsule': '\uEFFB',
    'navigate right': '\u25BB',
    'computer mouse': '\uEA40',
    downloadfolder: '\uEC76',
    'download cloud': '\uEB00',
    insertcapsule: '\uEFFB',
    'rain umbrella': '\uF270',
    'navigate left': '\u25C5',
    notifications: '\uD83D\uDD14',
    computermouse: '\uEA40',
    'business user': '\uE407',
    'call disabled': '\uE300',
    navigateright: '\u25BB',
    thermometerup: '\uF203',
    mediumbattery: '\uEA11',
    'bell disabled': '\uD83D\uDD15',
    'partly cloudy': '\u26C5',
    'measuring cup': '\uF162',
    'navigate down': '\uF501',
    pointdownleft: '\uF512',
    'sugar packets': '\uF135',
    'medium volume': '\uE803',
    'medical cross': '\uF4B0',
    'point up left': '\uF513',
    'crescent moon': '\uD83C\uDF19',
    'shopping cart': '\uE500',
    'upload folder': '\uEC77',
    phonedisabled: '\uE300',
    downloadcloud: '\uEB00',
    rainbowclouds: '\uF214',
    'download box': '\uEB02',
    'upload cloud': '\uEB40',
    navigatedown: '\uF501',
    'rotate right': '\u21BB',
    refrigerator: '\uF196',
    pointupright: '\uF510',
    'high battery': '\uEA10',
    'snow crystal': '\u2746',
    'full battery': '\uD83D\uDD0B',
    'mobile phone': '\uEA02',
    businessuser: '\uE407',
    crescentmoon: '\uD83C\uDF19',
    medicalcross: '\uF4B0',
    uploadfolder: '\uEC77',
    calldisabled: '\uE300',
    'cheese pizza': '\uEFE1',
    shoppingcart: '\uE500',
    measuringcup: '\uF162',
    rainumbrella: '\uF270',
    mediumvolume: '\uE803',
    thunderstorm: '\u26C8',
    sugarpackets: '\uF135',
    'french fries': '\uD83C\uDF5F',
    'coffee sugar': '\uEFF8',
    'skip forward': '\u23ED',
    navigateleft: '\u25C5',
    notification: '\uD83D\uDD14',
    'fast forward': '\u23E9',
    'partly sunny': '\u26C5',
    partlycloudy: '\u26C5',
    'weather vane': '\uF200',
    belldisabled: '\uD83D\uDD15',
    'pizza cutter': '\uF153',
    thermometer: '\uF201',
    weathervane: '\uF200',
    pizzacutter: '\uF153',
    'steam glass': '\uF199',
    'low battery': '\uEA12',
    'coffee milk': '\uEFF6',
    snowcrystal: '\u2746',
    'coffee bean': '\uEFF5',
    'chicken leg': '\uD83C\uDF57',
    highbattery: '\uEA10',
    'coffee foam': '\uEFF7',
    'raised hand': '\u270B',
    'floppy disk': '\uD83D\uDCBE',
    fullbattery: '\uD83D\uDD0B',
    'delete file': '\uEC04',
    mobilephone: '\uEA02',
    'remove file': '\uEC02',
    coffeesugar: '\uEFF8',
    'steam plate': '\uF198',
    cheesepizza: '\uEFE1',
    'point right': '\uD83D\uDC49',
    'thumbs down': '\uD83D\uDC4E',
    'navigate up': '\uF500',
    rotateright: '\u21BB',
    'medium snow': '\uF231',
    information: '\u2139',
    temperature: '\uF201',
    'storage box': '\uE901',
    'high volume': '\uD83D\uDD0A',
    'alarm clock': '\u23F0',
    partlysunny: '\u26C5',
    'rotate left': '\u21BA',
    pointupleft: '\uF513',
    photographs: '\uD83C\uDF04',
    'iced coffee': '\uEFF4',
    videocamera: '\uD83D\uDCF9',
    frenchfries: '\uD83C\uDF5F',
    skipforward: '\u23ED',
    'layer group': '\uE207',
    uploadcloud: '\uEB40',
    'credit card': '\uD83D\uDCB3',
    'open folder': '\uD83D\uDCC2',
    downloadbox: '\uEB02',
    'male avatar': '\uD83D\uDC64',
    'bell pepper': '\uF114',
    fastforward: '\u23E9',
    creditcard: '\uD83D\uDCB3',
    'scale down': '\uEE05',
    dishwasher: '\uF192',
    photograph: '\uD83C\uDF04',
    'wine glass': '\uD83C\uDF77',
    rotateleft: '\u21BA',
    storagebox: '\uE901',
    highvolume: '\uD83D\uDD0A',
    'low volume': '\uD83D\uDD09',
    icedcoffee: '\uEFF4',
    'grid lines': '\uE206',
    'disc drive': '\uEA42',
    thumbnails: '\uE9A3',
    headphones: '\uD83C\uDFA7',
    strawberry: '\uD83C\uDF53',
    screenshot: '\u2316',
    smartphone: '\uEA02',
    'hard drive': '\uE7B0',
    'heavy snow': '\uF232',
    'cell phone': '\uD83D\uDCF1',
    coffeebean: '\uEFF5',
    floppydisk: '\uD83D\uDCBE',
    bellpepper: '\uF114',
    directions: '\uE672',
    visibility: '\uD83D\uDC40',
    navigation: '\uE670',
    lowbattery: '\uEA12',
    coffeemilk: '\uEFF6',
    attachment: '\uD83D\uDCCE',
    calculator: '\uE551',
    'play video': '\uE8A1',
    'point left': '\uD83D\uDC48',
    'upload box': '\uEB42',
    'point down': '\uD83D\uDC47',
    mediumsnow: '\uF231',
    pointright: '\uD83D\uDC49',
    'light snow': '\uF230',
    steamglass: '\uF199',
    removefile: '\uEC02',
    'check file': '\uEC03',
    deletefile: '\uEC04',
    wheelchair: '\u267F',
    raisedhand: '\u270B',
    'user group': '\uE400',
    chickenleg: '\uD83C\uDF57',
    coffeefoam: '\uEFF7',
    openfolder: '\uD83D\uDCC2',
    maleavatar: '\uD83D\uDC64',
    navigateup: '\uF500',
    alarmclock: '\u23F0',
    'pull quote': '\u201C',
    layergroup: '\uE207',
    eyedropper: '\uE200',
    'no smoking': '\uD83D\uDEAD',
    steamplate: '\uF198',
    'rain heavy': '\uF224',
    'down right': '\u2B0A',
    thumbsdown: '\uD83D\uDC4E',
    disapprove: '\uD83D\uDC4E',
    usergroup: '\uE400',
    'skip back': '\u23EE',
    lightsnow: '\uF230',
    crosshair: '\u2316',
    documents: '\uEC00',
    musicnote: '\u266B',
    microwave: '\uF194',
    'pizza pie': '\uEFE0',
    checkfile: '\uEC03',
    newspaper: '\uD83D\uDCF0',
    wineglass: '\uD83C\uDF77',
    microchip: '\uE7C0',
    'pie chart': '\uE570',
    briefcase: '\uD83D\uDCBC',
    snowflake: '\u2744',
    lowvolume: '\uD83D\uDD09',
    lightbulb: '\uD83D\uDCA1',
    'male user': '\uD83D\uDC64',
    heavysnow: '\uF232',
    'bar chart': '\uD83D\uDCCA',
    paperclip: '\uD83D\uDCCE',
    backspace: '\u232B',
    'steam pot': '\uF19A',
    calculate: '\uE551',
    telephone: '\uD83D\uDCDE',
    pullquote: '\u201C',
    gridlines: '\uE206',
    stopwatch: '\u23F1',
    photocopy: '\uED42',
    harddrive: '\uE7B0',
    cigarette: '\uD83D\uDEAC',
    nosmoking: '\uD83D\uDEAD',
    macchiato: '\uEFF1',
    pointleft: '\uD83D\uDC48',
    uploadbox: '\uEB42',
    'egg timer': '\uF165',
    'down left': '\u2B0B',
    checkmark: '\u2713',
    lightning: '\u2607',
    downright: '\u2B0A',
    cellphone: '\uD83D\uDCF1',
    'thumbs up': '\uD83D\uDC4D',
    videogame: '\uD83C\uDFAE',
    playvideo: '\uE8A1',
    pointdown: '\uD83D\uDC47',
    scaledown: '\uEE05',
    discdrive: '\uEA42',
    rainheavy: '\uF224',
    cappucino: '\uEFF2',
    'scale up': '\uEE04',
    subtract: '\u002D',
    question: '\u2753',
    thumbsup: '\uD83D\uDC4D',
    downleft: '\u2B0B',
    favorite: '\u22C6',
    bookmark: '\uD83D\uDD16',
    keywords: '\uE100',
    contract: '\uEE01',
    eggtimer: '\uF165',
    trashcan: '\uE0D0',
    shredder: '\uED40',
    colander: '\uF163',
    umbrella: '\u2602',
    'up right': '\u2B08',
    'end call': '\uE300',
    envelope: '\u2709',
    utensils: '\uD83C\uDF74',
    insecure: '\uD83D\uDD13',
    maleuser: '\uD83D\uDC64',
    'sign out': '\uEE02',
    unlocked: '\uD83D\uDD13',
    pizzapie: '\uEFE0',
    'point up': '\uD83D\uDC46',
    'add file': '\uEC01',
    steampot: '\uF19A',
    download: '\uEB01',
    barchart: '\uD83D\uDCCA',
    piechart: '\uE570',
    navigate: '\uE670',
    broccoli: '\uF117',
    cucumber: '\uF116',
    signpost: '\uE672',
    location: '\uE6D0',
    previous: '\u25C5',
    database: '\uE7A0',
    'zoom out': '\uE003',
    computer: '\uD83D\uDCBB',
    notebook: '\uD83D\uDCD3',
    espresso: '\uEFF0',
    pictures: '\uD83C\uDF04',
    skipback: '\u23EE',
    capsule: '\uEFF9',
    'log out': '\uEE02',
    signout: '\uEE02',
    syncing: '\uEB82',
    loading: '\uEB83',
    speaker: '\uD83D\uDD08',
    'sign in': '\uEE03',
    scaleup: '\uEE04',
    droplet: '\uD83D\uDCA7',
    sunrise: '\uD83C\uDF05',
    addfile: '\uEC01',
    'zoom in': '\uE002',
    package: '\uD83D\uDCE6',
    endcall: '\uE300',
    avatars: '\uD83D\uDC65',
    checked: '\u2713',
    forward: '\u27A1',
    battery: '\uD83D\uDD0B',
    zoomout: '\uE003',
    airplay: '\uE800',
    compass: '\uE671',
    picture: '\uD83C\uDF04',
    tornado: '\uF213',
    approve: '\uD83D\uDC4D',
    shuffle: '\uD83D\uDD00',
    mpthree: '\uEC37',
    rainbow: '\uD83C\uDF08',
    compose: '\uD83D\uDCDD',
    toaster: '\uF193',
    visible: '\uD83D\uDC40',
    upright: '\u2B08',
    dislike: '\uD83D\uDC4E',
    bicycle: '\uD83D\uDEB2',
    'tea bag': '\uEFFC',
    laundry: '\uEA80',
    exhaust: '\uF144',
    freezer: '\uF197',
    unquote: '\u201D',
    printer: '\u2399',
    retweet: '\uF600',
    columns: '\uE9A2',
    'up left': '\u2B09',
    scanner: '\uED43',
    comment: '\uD83D\uDCAC',
    pointup: '\uD83D\uDC46',
    platter: '\uF166',
    desktop: '\uD83D\uDCBB',
    private: '\uD83D\uDD12',
    keyword: '\uE100',
    refresh: '\u21BB',
    monitor: '\uD83D\uDCBB',
    display: '\uD83D\uDCBB',
    pitcher: '\uF19B',
    warning: '\u26A0',
    caution: '\u26D4',
    smoking: '\uD83D\uDEAC',
    photos: '\uD83C\uDF04',
    coffee: '\u2615',
    clouds: '\uF220',
    orange: '\uD83C\uDF4A',
    carrot: '\uF111',
    cloudy: '\uF220',
    cheese: '\uF101',
    delete: '\u2421',
    remove: '\u002D',
    hyphen: '\u002D',
    signin: '\uEE03',
    'log in': '\uEE03',
    logout: '\uEE02',
    expand: '\u2922',
    copier: '\uED42',
    folder: '\uD83D\uDCC1',
    upload: '\uEB41',
    sunset: '\uD83C\uDF07',
    teabag: '\uEFFC',
    washer: '\uEA80',
    mobile: '\uEA02',
    iphone: '\uEA02',
    tablet: '\uEA01',
    kettle: '\uF19C',
    laptop: '\uEA00',
    replay: '\u21BA',
    repeat: '\uD83D\uDD01',
    rewind: '\u23EA',
    record: '\u25CF',
    gaming: '\uD83C\uDFAE',
    webcam: '\uEA41',
    videos: '\uD83D\uDCF9',
    grapes: '\uD83C\uDF47',
    images: '\uD83C\uDF04',
    camera: '\uD83D\uDCF7',
    volume: '\uD83D\uDD08',
    locate: '\uE670',
    fridge: '\uF196',
    female: '\uE451',
    avatar: '\uD83D\uDC64',
    hanger: '\uF1A0',
    outbox: '\uD83D\uDCE4',
    raster: '\uE2A1',
    pixels: '\uE2A1',
    vector: '\uE2A0',
    bezier: '\uE2A0',
    layers: '\uE202',
    sample: '\uE200',
    tagged: '\uE100',
    upleft: '\u2B09',
    plates: '\uF167',
    target: '\u25CE',
    public: '\uD83D\uDD13',
    unlock: '\uD83D\uDD13',
    drinks: '\uF12A',
    secure: '\uD83D\uDD12',
    locked: '\uD83D\uDD12',
    eraser: '\u2710',
    pencil: '\u270E',
    unlink: '\uE011',
    attach: '\uD83D\uDCCE',
    zoomin: '\uE002',
    search: '\uD83D\uDD0E',
    cursor: '\uE001',
    write: '\u270E',
    merge: '\uEB81',
    share: '\uF601',
    trash: '\uE0D0',
    pause: '\uE8A0',
    email: '\u2709',
    login: '\uEE03',
    phone: '\uD83D\uDCDE',
    pizza: '\uD83C\uDF55',
    enter: '\uEE03',
    inbox: '\uD83D\uDCE5',
    house: '\u2302',
    quote: '\u201C',
    sugar: '\uF134',
    mouse: '\uEA40',
    stove: '\uF141',
    apple: '\uD83C\uDF4F',
    globe: '\uD83C\uDF0E',
    steam: '\u2668',
    earth: '\uD83C\uDF0E',
    print: '\u2399',
    rainy: '\u2614',
    lemon: '\uD83C\uDF4B',
    onion: '\uF115',
    pages: '\uEC00',
    minus: '\u002D',
    image: '\uD83C\uDF04',
    music: '\u266B',
    check: '\u2713',
    bread: '\uD83C\uDF5E',
    whisk: '\uF152',
    cloud: '\u2601',
    photo: '\uD83C\uDF04',
    sunny: '\u2600',
    world: '\uD83C\uDF0E',
    eject: '\u23CF',
    close: '\u2421',
    latte: '\uEFF3',
    audio: '\u266B',
    woman: '\uD83D\uDC69',
    video: '\uD83D\uDCF9',
    shred: '\uED40',
    erase: '\u2710',
    women: '\uE451',
    users: '\uD83D\uDC65',
    index: '\uE902',
    sound: '\uD83D\uDD08',
    clock: '\u23F2',
    right: '\u27A1',
    alert: '\u26A0',
    timer: '\u23F1',
    alarm: '\u23F0',
    heart: '\u2665',
    files: '\uEC00',
    chef: '\uF172',
    cups: '\uF12A',
    vent: '\uF143',
    oven: '\uF140',
    drop: '\uD83D\uDCA7',
    milk: '\uF126',
    zoom: '\uE002',
    view: '\uD83D\uDC40',
    look: '\uD83D\uDC40',
    mugs: '\uF12B',
    link: '\uD83D\uDD17',
    peas: '\uF112',
    move: '\uE070',
    eggs: '\uF107',
    next: '\u25BB',
    time: '\u23F2',
    bell: '\uD83D\uDD14',
    rain: '\u2614',
    edit: '\u270E',
    plus: '\u002B',
    exit: '\uEE02',
    info: '\u2139',
    help: '\u2753',
    scan: '\uED43',
    lock: '\uD83D\uDD12',
    tags: '\uE100',
    back: '\u2B05',
    left: '\u2B05',
    flag: '\u2691',
    like: '\uD83D\uDC4D',
    wind: '\uF212',
    down: '\u2B07',
    love: '\u2665',
    star: '\u22C6',
    crop: '\uE201',
    file: '\uD83D\uDCC4',
    sync: '\uEB82',
    snow: '\uF231',
    redo: '\u21BB',
    fork: '\uEB80',
    idea: '\uD83D\uDCA1',
    cell: '\uD83D\uDCF1',
    hail: '\uF244',
    ipad: '\uEA01',
    call: '\uD83D\uDCDE',
    rows: '\uE9A1',
    news: '\uD83D\uDCF0',
    mail: '\u2709',
    undo: '\u21BA',
    skip: '\u23ED',
    stop: '\u25A0',
    play: '\u25B6',
    film: '\uE8B0',
    chat: '\uD83D\uDCAC',
    save: '\uD83D\uDCBE',
    home: '\u2302',
    talk: '\uD83D\uDCAC',
    comb: '\uF1A1',
    bike: '\uD83D\uDEB2',
    cart: '\uE500',
    hand: '\uE410',
    user: '\uD83D\uDC64',
    male: '\uE450',
    work: '\uD83D\uDCBC',
    book: '\uD83D\uDCD5',
    man: '\uD83D\uDC68',
    fan: '\uF280',
    box: '\uD83D\uDCE6',
    hdd: '\uE7B0',
    jug: '\uF126',
    pot: '\uF168',
    usb: '\uEB86',
    pen: '\u2712',
    exe: '\uEC30',
    zip: '\uEC31',
    doc: '\uEC32',
    pdf: '\uEC34',
    fog: '\uF211',
    jpg: '\uEC35',
    men: '\uE450',
    rar: '\uEC38',
    gif: '\uEC39',
    tag: '\uE100',
    ban: '\uD83D\uDEAB',
    key: '\uD83D\uDD11',
    fax: '\uD83D\uDCE0',
    add: '\u002B',
    egg: '\uF100',
    tea: '\uD83C\uDF75',
    mug: '\u2615',
    sun: '\u2600',
    eye: '\uD83D\uDC40',
    png: '\uEC36',
    za: '\uD83C\uDF55',
    up: '\u2B06',
  };

  if (typeof ss_icons !== 'object' || typeof ss_icons !== 'object') {
    var ss_icons = ss_set;
    var ss_keywords = [];
    for (var i in ss_set) {
      ss_keywords.push(i);
    }
  } else {
    for (var i in ss_set) {
      ss_icons[i] = ss_set[i];
      ss_keywords.push(i);
    }
  }

  if (typeof ss_legacy !== 'function') {
    /* domready.js */
    !(function (a, b) {
      typeof module !== 'undefined'
        ? (module.exports = b())
        : typeof define === 'function' && typeof define.amd === 'object'
          ? define(b)
          : (window[a] = b());
    })('ss_ready', (a) => {
      function m(a) {
        l = 1;
        while ((a = b.shift())) a();
      }
      var b = [];
      let c;
      const d = !1;
      const e = document;
      const f = e.documentElement;
      const g = f.doScroll;
      const h = 'DOMContentLoaded';
      const i = 'addEventListener';
      const j = 'onreadystatechange';
      const k = 'readyState';
      var l = /^(loade|c)/.test(e[k]);
      return (
        e[i] &&
          e[i](
            h,
            (c = function () {
              (e.removeEventListener(h, c, d), m());
            }),
            d
          ),
        g &&
          e.attachEvent(
            j,
            (c = function () {
              /^c/.test(e[k]) && (e.detachEvent(j, c), m());
            })
          ),
        (a = g
          ? function (c) {
              self != top
                ? l
                  ? c()
                  : b.push(c)
                : (function () {
                    try {
                      f.doScroll('left');
                    } catch (b) {
                      return setTimeout(() => {
                        a(c);
                      }, 50);
                    }
                    c();
                  })();
            }
          : function (a) {
              l ? a() : b.push(a);
            })
      );
    });

    var ss_legacy = function (node) {
      if ((!node) instanceof Object) return false;

      if (node.length) {
        for (let i = 0; i < node.length; i++) {
          ss_legacy(node[i]);
        }
        return;
      }

      if (node.value) {
        node.value = ss_liga(node.value);
      } else if (node.nodeValue) {
        node.nodeValue = ss_liga(node.nodeValue);
      } else if (node.innerHTML) {
        node.innerHTML = ss_liga(node.innerHTML);
      }
    };

    const ss_getElementsByClassName = function (node, classname) {
      const a = [];
      const re = new RegExp(`(^| )${classname}( |$)`);
      const els = node.getElementsByTagName('*');
      for (let i = 0, j = els.length; i < j; i++) if (re.test(els[i].className)) a.push(els[i]);
      return a;
    };

    var ss_liga = function (that) {
      const re = new RegExp(ss_keywords.join('|').replace(/[-[\]{}()*+?.,\\^$#\s]/g, '\\$&'), 'gi');
      return that.replace(re, (v) => ss_icons[v.toLowerCase()]);
    };

    ss_ready(() => {
      if (document.getElementsByClassName) {
        ss_legacy(document.getElementsByClassName('ss-icon'));
      } else {
        ss_legacy(ss_getElementsByClassName(document.body, 'ss-icon'));
      }
    });
  }
}
